import React from "react";
import "../../scss/dashboard/misplantillasdiv.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEdit, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import DashGraph from "./DashGraph";
import { getPrice } from "../../utils";
import { useModalsDispatch, OPEN_PREVIEW } from "../../context/modals";
import bootbox from "../Bootbox";
import { NavLink, Link } from "react-router-dom";

function MisPlantillasDiv({
  _id,
  name,
  description,
  type,
  template,
  sold,
  stripeInfo,
  onPreview,
  onRemove,
}) {
  const handlePreview = () => {
    onPreview(template);
  };
  const handleRemove = async () => {
    const resp = await bootbox.confirm(
      "¿Estas seguro de eliminar esta Plantilla? Se borrara la información permanentemente del sistema?"
    );
    if (!resp) return;
    onRemove(template, { _id, name, description, type, sold, stripeInfo });
  };

  return (
    <div className="misplantillasdiv__container">
      <div className="misplantillasdiv__container--h5">
        <h5 style={{ fontWeight: "600" }}>{name} </h5>
      </div>
      <div className="misplantillasdiv__container--description">
        <p>{description}</p>
      </div>
      <div className="misplantillasdiv__container--value">
        <p>
          {type === "premium"
            ? getPrice(stripeInfo?.price, stripeInfo?.currency)
            : "Gratis"}
        </p>
      </div>
      <div
        className="misplantillasdiv__container--vendidas"
        style={{ position: "relative" }}
      >
        <p>
          {sold}
          <br />
          Ventas
        </p>
        <div
          style={{
            display: "flex",
            flexFlow: "column",
            position: "absolute",
            top: "-1.7rem",
            right: "10%",
          }}
        >
          <DashGraph />
          <p
            style={{
              color: "#04d09a",
              position: "absolute",
              bottom: "1rem",
              right: "0px",
            }}
          >
            Performance
          </p>
        </div>
      </div>
      <div className="misplantillasdiv__container--options">
        <div className="cursor-pointer" onClick={handlePreview}>
          <p>
            <FontAwesomeIcon icon={faEye} color={"#9ea0a5"} />
          </p>
        </div>
        <NavLink
          className="misplantillasdiv__container--options--div2 cursor-pointer"
          to={`/lawyers/templates/${_id}/edit`}
        >
          <p>
            <FontAwesomeIcon icon={faEdit} color={"#9ea0a5"} />
          </p>
        </NavLink>
        <div
          className="misplantillasdiv__container--options--div3 cursor-pointer"
          style={{ cursor: "pointer" }}
          onClick={handleRemove}
        >
          <p>
            <FontAwesomeIcon icon={faTrashAlt} color={"#9ea0a5"} />
          </p>
        </div>
      </div>
    </div>
  );
}

export default MisPlantillasDiv;
